module.exports = __webpack_public_path__ + "static/media/loadingspinner.719ebaf3.svg";